import { render, staticRenderFns } from "./ChooseAccountModal.vue?vue&type=template&id=48f4ce47&"
import script from "./ChooseAccountModal.vue?vue&type=script&lang=js&"
export * from "./ChooseAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports